import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function CircleArrow({
  color = 'icon.primary',
  fill = 'transparent',
  stroke = '1',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 16 16' {...props}>
      <Path
        d='M8.50781 10.2759L6.22698 7.99506L8.50781 5.71423'
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M6.22266 7.99603L13.6909 7.99603C14.2587 7.99645 14.7188 8.45687 14.7188
          9.02469V9.02469C14.7185 10.455 14.1519 11.827 13.1427 12.8405V12.8405C11.7831
          14.2022 9.93735 14.9666 8.01311 14.9648C4.5634 14.9789 1.62051 12.4714
          1.08688 9.06314C0.553244 5.65493 2.58886 2.3679 5.87781 1.32697C9.16675
          0.286032 12.7229 1.80329 14.2474 4.89791'
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}

CircleArrow.propTypes = {
  color: PropTypes.string,
  stroke: PropTypes.string,
  fill: PropTypes.string,
}

export default CircleArrow
